export function getFlagFromSearch(searchParams: URLSearchParams, key: string) {
  return searchParams.get(key) === '1' || searchParams.get(key) === 'true';
}

// URL flag helpers (panel routing)
export const flag = (k: string) => new URLSearchParams(window.location.search).get(k) === '1';
export const idFromFlag = (k: string) => new URLSearchParams(window.location.search).get(k) || null;

export function pushFlag(k: string, v: '1') {
  const p = new URLSearchParams(window.location.search);
  p.set(k, v);
  const qs = p.toString();
  const url = `${window.location.pathname}${qs ? `?${qs}` : ''}`;
  window.history.pushState(null, '', url);
  // Notify listeners so components that read window.location.search re-evaluate
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function pushIdFlag(k: string, id: string) {
  const p = new URLSearchParams(window.location.search);
  p.set(k, id);
  const qs = p.toString();
  const url = `${window.location.pathname}${qs ? `?${qs}` : ''}`;
  window.history.pushState(null, '', url);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function replaceClearFlags(keys: string[]) {
  const p = new URLSearchParams(window.location.search);
  keys.forEach(k => p.delete(k));
  const qs = p.toString();
  const url = `${window.location.pathname}${qs ? `?${qs}` : ''}`;
  window.history.replaceState(null, '', url);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function setPageInUrl(page: number) {
  const p = new URLSearchParams(window.location.search);
  if (page > 1) p.set('page', String(page));
  else p.delete('page');
  const qs = p.toString();
  const url = `${window.location.pathname}${qs ? `?${qs}` : ''}`;
  window.history.replaceState(null, '', url);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function getPageFromUrl(): number {
  const p = new URLSearchParams(window.location.search);
  const val = parseInt(p.get('page') || '1', 10);
  return isNaN(val) || val < 1 ? 1 : val;
}

export function focusRef(testId: string) {
  try {
    const el = document.querySelector<HTMLElement>(`[data-ref="${testId}"]`);
    el?.focus();
  } catch {
    // no-op
  }
}
